/* eslint-disable no-unused-vars */
import {
  Btn,
  Logo,
  NavLink,
  NavbarCon,
  SearchMenu,
  HeaderMenu,
  ContactLink,
  UserDropDown,
  HamburgerMenu,
  HeaderContainer,
  SearchContainer,
  NavbarContainer,
} from "./NavbarStyles";
import "./header.css";
import "antd/dist/antd.min.css";
import NewButton from "../newButton";
import { Divider, Input } from "antd";
import water from "assets/icons/water.svg";
// import { getFavorite } from 'utils/helpers';
import { useAuth, useActivity } from "hooks";
import logo from "assets/images/cwaylogo.png";
import { BiCategoryAlt } from "react-icons/bi";
import { navBarRoutes } from "constants/navbar";
import callIcon from "assets/icons/nav_call.svg";
import cartIcon from "assets/icons/cart-icon.svg";
import userIcon from "assets/icons/user-icon.svg";
import angleDown from "assets/icons/angleDown.svg";
import React, { useState, useEffect } from "react";
import favIcon from "assets/icons/favorite-icon.svg";
import { useNavigate, Link } from "react-router-dom";
import { getFav } from 'services/carts';
import MenuOutlined from "@ant-design/icons/MenuOutlined";
import CloseOutlined from "@ant-design/icons/CloseOutlined";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { getToken } from "utils/helpers";
import toast from "react-hot-toast";



const Navbar = ({ routes = [] }) => {
  // Hooks
  const navigate = useNavigate();
  const { stateAuth, logUserOut, userProfile } = useAuth();
  const { state, getCategories, fetchFavourites, adds, fetchProducts } = useActivity();

  // Favorite state hook
  const [open, setOpen] = useState(0);
  const [mobile, setIsMobile] = useState(false); // Mobile Nav Function
  const [category, setCategory] = useState(null); // Category state hook
  const [links, setLinks] = useState(navBarRoutes); // the default navbar links
  // const [favorite] = useState(getFavorite()?.length ?? 0); // Favorite state hook
  const [userNav, setUserNav] = useState(null); // this toggles the user dropdown menu (only if user is logged in)
  const [searchQuery, setSearchQuery] = useState("");

  const getFavs = async () => {
    try {

      const res = await getFav();
      if (res?.status) {
        fetchFavourites(res?.data);
        return;
      }
    } catch (err) {

      console.log(err?.response?.data)
    }
  }

  // Use effects
  useEffect(() => {
    getCategories();
    adds();
    // Only fetch profile when authenticated (prevents 401 from flipping auth state)
    if (getToken()) {
      userProfile();
    }
    if (stateAuth.isAuthenticated) {
      getFavs()
    }

  }, [stateAuth.isAuthenticated,]); // fetches the categories

  // Load catalog once for other pages; do not list `fetchProducts` in deps — it is a new
  // function reference every render from useActivity() and would retrigger this effect forever
  // while products.length === 0 (network tab spam + frozen "Page not responding").
  useEffect(() => {
    if (!state?.products?.length) {
      fetchProducts();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.products?.length]);
  useEffect(() => (window.onscroll = () => mobile && setIsMobile(false)), []); // listens to window scrolling event
  // adds the first five categories to the navlinks

  // Methods
  const handleSearchClick = () => {
    const q = searchQuery.trim();
    if (!q) {
      toast.error("Type a product name to search");
      return;
    }
    navigate(`/search?q=${encodeURIComponent(q)}`);
    setSearchQuery("");
  };

  const capitalizeFirstLetter = (str) => {
    if (str == null || str === "") return "";
    const capitalized = str.replace(/^./, str[0].toUpperCase());
    return capitalized;
  }


  // Attributes
  const navLinkClassName = "navside";
  const navLinkIconClassName = "d-md-none mr-2 d-lg-none";
  const inputStyles = {
    border: "2px solid #6d8dbf",
    borderRadius: "5px",
    fontSize: "0.75rem",
  };

  return (
    <>
      <HeaderContainer className="mt-3 position-sticky">
        <HamburgerMenu onClick={() => setOpen(!open)}>
          {open ? <CloseOutlined size={10} /> : <MenuOutlined />}
        </HamburgerMenu>

        <Logo onClick={() => navigate("/")}>
          <img src={logo} alt="logo" />
        </Logo>

        <SearchMenu className="me-lg-2">
          <SearchContainer>
            <Input
              allowClear
              className="py-1"
              style={{ width: "100%", ...inputStyles }}
              placeholder="Search products…"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onPressEnter={handleSearchClick}
            />
          </SearchContainer>

          <NewButton
            label="SEARCH"
            className="mx-2"
            onClick={handleSearchClick}
          />
        </SearchMenu>

        <HeaderMenu>
          <span
            className="favorite span ms-lg-5"
            onClick={() => { !stateAuth.isAuthenticated ? navigate('/login', { replace: true }) : navigate("/favorites", { replace: true }) }
            }
          >
            <img src={favIcon} alt="Favorite" />
            <i className="ps-1">Favorites</i>
            {stateAuth?.isAuthenticated && state.favourites.length > 0 ? (
              <b>{state.favourites.length}</b>
            ) : null}
          </span>
          <span className="span">
            <img onClick={() => { stateAuth?.isAuthenticated ? setUserNav(!userNav) : navigate("/login") }} src={userIcon} alt="User" />
            {stateAuth?.isAuthenticated ? (
              <i onClick={() => setUserNav(!userNav)}>
                {stateAuth?.user?.username ? capitalizeFirstLetter(stateAuth?.user?.username) : "My Account"}
                <img
                  className="ms-1"
                  src={angleDown}
                  style={{ width: '15px' }}
                  alt="dropdown"
                />
                <UserDropDown show={userNav}>
                  <Link to="/account-info">account info</Link>
                  <Link to="/orders">orders</Link>
                  <Link to="#" onClick={() => logUserOut()}>
                    log out
                  </Link>
                </UserDropDown>
              </i>
            ) : (
              <>
                {stateAuth?.loading ? (
                  <span>Profile loading.....</span>
                ) : (
                  <>
                    <i className="ps-1" onClick={() => navigate("/login")}>
                      Login /
                    </i>
                    <i className="ps-1" onClick={() => navigate("/register")}>
                      Signup
                    </i>
                  </>
                )}
              </>
            )}
          </span>
          <span className="span" onClick={() => navigate("/cart")}>
            <img src={cartIcon} alt="Cart" />
            <i className="ps-1">Cart</i>{" "}
            {state.cart?.length > 0 ? <b>{state.cart?.map((data) => +data.quantity).reduce((a, b) => a + b)}</b> : null}
          </span>
        </HeaderMenu>
      </HeaderContainer>
      <Divider className="my-0" />

      <NavbarContainer>
        <Btn
          className={category ? "open" : ""}
          onClick={() => setCategory(!category)}
        >
          <BiCategoryAlt />
          browse all categories
          {category ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
          <div className="modal">

            {state.allCategories.length > 0 && state.allCategories?.map(
              (
                item,
                id // other links from props
              ) => (
                <NavLink key={id} to={`/category/${item?.name}/${item?.id}`} className={navLinkClassName}>
                  <img style={{ width: "20px" }} src={item?.image_url} alt="" />{item?.name}
                </NavLink>
              )
            )}
          </div>
        </Btn>

        <NavbarCon open={open}>

          <NavLink to={`/`} className={navLinkClassName}>
            Home
          </NavLink>
          <NavLink to={`/store`} className={navLinkClassName}>
            Store
          </NavLink>
          {state.allCategories.length > 0 && state.allCategories?.filter((data) => data?.visible === 1)?.map(
            (
              item,
              id // other links from props
            ) => (
              <NavLink key={id} to={`/category/${item?.name}/${item?.id}`} className={navLinkClassName}>
                {item?.name}
              </NavLink>
            )
          )}
        </NavbarCon>

        <ContactLink>
          <div className="info">
            <h3><img style={{ width: '25px' }} src={callIcon} alt="call" /><a style={{ color: "#5d84c1" }} href="tel:(+234)-903 3031 123">(+234)-903 3031 123</a></h3>
            <span>Monday - Friday 8am - 5pm</span>
            <span>Saturdays 9am - 4pm</span>
          </div>
        </ContactLink>
      </NavbarContainer>

      <Divider className="my-0" />
    </>
  );
};

export default Navbar;
